module.exports = __webpack_public_path__ + "img/19.5.COD.1b83b784.png";